export default __webpack_public_path__ + "static/media/Order.e7a3e37a.jpg";